import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { MessageService, SharedModule } from 'primeng/api';
import { Button } from 'primeng/button';
import { Dialog } from 'primeng/dialog';
import { TableModule } from 'primeng/table';
import Detail from '../../../../../../types/detail/Detail';
import SampleCategory from '../../../../../../types/sample-category/SampleCategory';
import { DetailService } from '../../../../services/detail.service';
import { SampleCategoryService } from '../../../../services/sample-category.service';

@Component({
    selector: 'app-set-sample-categories-dialog',
    imports: [
        Dialog,
        TableModule,
        Button,
        SharedModule
    ],
    templateUrl: './set-sample-categories-dialog.component.html',
    styleUrl: './set-sample-categories-dialog.component.scss'
})
export class SetSampleCategoriesDialogComponent implements OnChanges {

    @Input() visible: boolean = false;
    @Input() detail: Detail | null = null;
    @Output() visibleChange: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Output() saved: EventEmitter<any> = new EventEmitter<any>();

    public saving = false;
    public loadingCategories = false;
    public categories: SampleCategory[] = [];
    public selectedCategories: SampleCategory[] = [];

    constructor(private detailService: DetailService,
                private categoryService: SampleCategoryService,
                private messageService: MessageService) {
    }

    public close(): void {
        this.visible = false;
        this.visibleChange.emit(this.visible);
    }

    public ngOnChanges(changes: SimpleChanges): void {
        if (changes['visible'] && changes['visible'].currentValue) {
            this.loadCategories();
        }
    }

    public loadCategories(): void {
        this.categoryService.getAllSampleCategories().then(
            (categories: SampleCategory[]) => {
                this.categories = categories;
                this.loadDetailCategories();
            }
        ).catch(error => {
            this.messageService.add(
                { severity: 'error', summary: 'Failed to load sample categories', detail: error.message });
        }).finally(() => {
            this.loadingCategories = false;
        });
    }

    public loadDetailCategories(): void {
        if (this.detail) {
            this.categoryService.getSampleCategoriesByDetailId(this.detail?.id).then(
                (categories: SampleCategory[]) => {
                    this.selectedCategories = categories;
                }
            ).catch(error => {
                this.messageService.add(
                    { severity: 'error', summary: 'Failed to load sample categories', detail: error.message });
            });
        }
    }

    public save() {
        this.saving = true;
        if (!this.detail) {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'No detail provided' });
            return;
        }
        this.detailService.setCategoriesForDetail(this.detail?.id, this.selectedCategories.map(c => c.id))
            .then(() => {
                this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Categories set' });
                this.saved.emit();
                this.close();
            }).catch(() => {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to set categories' });
        }).finally(() => {
            this.saving = false;
        });
    }
}
